import { render, staticRenderFns } from "./SelectedGoods.vue?vue&type=template&id=55124433&scoped=true"
import script from "./SelectedGoods.vue?vue&type=script&lang=js"
export * from "./SelectedGoods.vue?vue&type=script&lang=js"
import style0 from "./SelectedGoods.vue?vue&type=style&index=0&id=55124433&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55124433",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55124433')) {
      api.createRecord('55124433', component.options)
    } else {
      api.reload('55124433', component.options)
    }
    module.hot.accept("./SelectedGoods.vue?vue&type=template&id=55124433&scoped=true", function () {
      api.rerender('55124433', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/salesPromotion/list/modules/SelectedGoods/SelectedGoods.vue"
export default component.exports